<template>
  <div class="tlds-page admin-page">
    <header class="admin-page__header">
      <div class="admin-page__title">
        <h2>TLD 价格表</h2>
        <p>维护各顶级域注册与续费价格</p>
      </div>
      <a-button type="primary" icon="plus" @click="openCreate">新增</a-button>
    </header>

    <a-card :bordered="false" class="admin-card">
      <a-table
        :columns="cols"
        :data-source="rows"
        :rowKey="r => r.tld"
        :loading="loading"
        :pagination="false"
        size="middle"
        class="admin-table"
      >
        <template slot="tld" slot-scope="text">
          <span class="tld-badge">{{ text }}</span>
        </template>
        <template slot="enabled" slot-scope="text">
          <span class="status-pill" :class="text ? 'is-on' : 'is-off'">
            <i></i>{{ text ? '启用' : '停用' }}
          </span>
        </template>
        <template slot="action" slot-scope="_, r">
          <a class="row-action" @click="openEdit(r)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除该 TLD?" @confirm="onDelete(r)">
            <a class="row-action is-danger">删除</a>
          </a-popconfirm>
        </template>
      </a-table>
    </a-card>

    <a-modal
      :visible="modalOpen"
      :title="modalTitle"
      @ok="onSave"
      @cancel="modalOpen = false"
      :destroy-on-close="true"
      :width="480"
    >
      <a-form-model :model="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }">
        <a-form-model-item label="TLD">
          <a-input v-model="form.tld" :disabled="editing" placeholder=".com / .shop / .xyz" />
        </a-form-model-item>
        <a-form-model-item label="售价 (U)">
          <a-input-number v-model="form.price_u" :min="0" :step="0.01" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item label="续费 (U) (选填)">
          <a-input-number v-model="form.renew_price_u" :min="0" :step="0.01" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item label="排序">
          <a-input-number v-model="form.sort_order" style="width:100%" />
        </a-form-model-item>
        <a-form-model-item label="启用">
          <a-switch v-model="form.enabled" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { listTlds, saveTld, deleteTld } from '@/api/tlds';

export default {
  data() {
    return {
      loading: false,
      rows: [],
      modalOpen: false,
      editing: false,
      form: this.emptyForm(),
      cols: [
        { title: 'TLD', dataIndex: 'tld', width: 140, scopedSlots: { customRender: 'tld' } },
        { title: '售价 (U)', dataIndex: 'price_u', width: 120 },
        { title: '续费 (U)', dataIndex: 'renew_price_u', width: 120 },
        { title: '排序', dataIndex: 'sort_order', width: 100 },
        { title: '状态', dataIndex: 'enabled', scopedSlots: { customRender: 'enabled' }, width: 100 },
        { title: '操作', scopedSlots: { customRender: 'action' }, width: 140 },
      ],
    };
  },
  computed: {
    modalTitle() {
      return this.editing ? '编辑 TLD' : '新增 TLD';
    },
  },
  mounted() {
    this.refresh();
  },
  methods: {
    emptyForm() {
      return { tld: '', price_u: 10, renew_price_u: null, enabled: true, sort_order: 0 };
    },
    refresh() {
      this.loading = true;
      listTlds()
        .then(res => {
          this.rows = (res.data || []).map(r => ({ ...r, enabled: !!r.enabled }));
        })
        .catch(e => this.$message.error((e && e.data && e.data.message) || '加载失败'))
        .finally(() => (this.loading = false));
    },
    openCreate() {
      this.form = this.emptyForm();
      this.editing = false;
      this.modalOpen = true;
    },
    openEdit(r) {
      this.form = { ...r, enabled: !!r.enabled };
      this.editing = true;
      this.modalOpen = true;
    },
    onSave() {
      saveTld({ ...this.form, enabled: this.form.enabled ? 1 : 0 })
        .then(() => {
          this.$message.success('已保存');
          this.modalOpen = false;
          this.refresh();
        })
        .catch(e => this.$message.error((e && e.data && e.data.message) || '保存失败'));
    },
    onDelete(r) {
      deleteTld(r.tld)
        .then(() => {
          this.$message.success('已删除');
          this.refresh();
        })
        .catch(e => this.$message.error((e && e.data && e.data.message) || '删除失败'));
    },
  },
};
</script>
</content>
</invoke>